import { useTranslation } from 'react-i18next';
import { Container, Row } from 'react-bootstrap';
import { Flex, Text } from 'theme-ui';
import { Icon } from '@velove/design-system';
import { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { PackageStatusType } from '../../contexts/contextTypes';

const FailedContainer = () => {
  const { t } = useTranslation();
  const { trackingDetails, partner, settings } = useContext(AppContext);
  const packageStatus = trackingDetails?.package?.status;

  let header = t('failed.failed_heading');
  let summary = t('failed.failed_paragraph');

  if (packageStatus === PackageStatusType.CANCELLED) {
    header = t('cancelled.cancelled_heading');
    summary = t('cancelled.cancelled_paragraph');
  } else if (packageStatus === PackageStatusType.BROKEN) {
    header = t('broken.broken_heading');
    summary = t('broken.broken_paragraph');
  } else if (packageStatus === PackageStatusType.RETURNED_TO_MERCHANT) {
    header = t('returned.returned_heading').replace(/(##partnerName##)/, settings?.displayName || partner?.name || 'Velove');
    summary = t('returned.returned_paragraph').replace(/(##partnerName##)/, settings?.displayName || partner?.name || 'Velove');
  } else if (packageStatus === PackageStatusType.LOST) {
    header = t('lost.lost_heading');
    summary = t('lost.lost_paragraph');
  }

  return (
    <Container>
      <Row className="home_container">
        <div className="summary_container">
          <Flex
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              columnGap: '15px',
              marginBottom: 25
            }}
          >
            <Icon
              icon="Warning"
              sx={{
                height: '60px',
                width: '60px',
                color: '#F00001',
                '@media screen and (max-width: 425px)': {
                  height: '100px',
                  width: '100px'
                },
                '@media screen and (max-width: 375px)': {
                  height: '80px',
                  width: '80px'
                }
              }}
            ></Icon>
            <Text
              sx={{
                fontWeight: 500,
                fontSize: '20pt',
                '@media screen and (max-width: 768px)': {
                  fontSize: '18pt'
                },
                '@media screen and (max-width: 425px)': {
                  fontSize: '15pt'
                },
                '@media screen and (max-width: 375px)': {
                  fontSize: '13pt'
                },
                display: 'flex',
                alignItems: 'center'
              }}
            >
              {header}
            </Text>
          </Flex>
          <p>{summary}</p>
        </div>
      </Row>
    </Container>
  );
};

export default FailedContainer;
